const btnTableTileMatOverrides = {
  export: 'Export data',
  addRowLabel: 'add',
  options: 'options',
  exportChecklist: 'Export checklist',
  import: 'Import',
  importData: 'Import data',
};

export default btnTableTileMatOverrides;
